import React from 'react';
import { testimonials } from '../mock';

const TestimonialsPage = () => {
  return (
    <div>
      {/* Header */}
      <section className="section-padding-small">
        <div className="container">
          <h1 className="hero-large" style={{ marginBottom: '24px' }}>
            Client Testimonials
          </h1>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '800px' }}>
            Read what our clients have to say about their transformational experiences with Get Lucid.
          </p>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section style={{ paddingBottom: '120px' }}>
        <div className="container">
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
            gap: '32px'
          }}>
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} style={{
                padding: '40px',
                background: 'var(--bg-secondary)',
                borderRadius: '0px',
                display: 'flex',
                flexDirection: 'column',
                gap: '24px'
              }}>
                {/* Initials Circle */}
                <div style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  background: 'var(--bg-primary)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '18px',
                  fontWeight: 500,
                  color: 'var(--text-primary)',
                  fontFamily: "'Cormorant Garamond', serif"
                }}>
                  {testimonial.initials}
                </div>

                {/* Quote */}
                <p className="body-regular" style={{
                  color: 'var(--text-secondary)',
                  lineHeight: '1.7',
                  fontStyle: 'italic'
                }}>
                  "{testimonial.quote}"
                </p>

                {/* Author */}
                <p className="body-regular" style={{
                  fontWeight: 500,
                  color: 'var(--text-primary)'
                }}>
                  — {testimonial.author}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default TestimonialsPage;
